import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as _ from 'underscore';

// Service
import { ExperienceListService } from '../../service/experience-list/experience-list.service';

@Component({
	selector: 'app-experience-list',
	templateUrl: './experience-list.component.html',
	providers: [
		ExperienceListService,
		HttpModule
	]
})
export class ExperienceListComponent implements OnInit {

	private token;
	public experiences: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Descricao";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	experience: FormGroup;

	constructor(fb: FormBuilder, private experienceListService: ExperienceListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.experience = fb.group({
			'Descricao': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchExperience(this.experience.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchExperience(this.experience.value, this.currentPage, false);
	}

	searchExperience(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Descricao";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.experienceListService.searchExperience(this.token, value.Descricao, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.experiences = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchExperience(this.experience.value, $event, false);
	}

}


// WEBPACK FOOTER //
// ./src/app/experience/component/experience-list/experience-list.component.ts